export const messages = {
  redirect: "The access token is invalid/expired, will redirect you to login",
  logout: "Logging you out",
  success: "Access Token found in LocalStorage will redirect to target application",
  error:
    "There is an issue retrieving the access token in localStorage. Please check Local Storage content if the token is present",
};
